import React, { useMemo } from 'react'
import {useStyleContext} from "../../../customHooks/useStyleContext";

function normalizeMoneyInput(value) {
    if (value == null) return null;
    if (typeof value === 'number') return Number.isFinite(value) ? value : null;
    if (typeof value !== 'string') return null;

    const s = value
        .trim()
        .replace(/[\s\u00A0\u202F]/g, '')
        .replace(',', '.');

    if (s === '') return null;
    const n = Number(s);
    return Number.isFinite(n) ? n : null;
}

function formatMoneyInline(value, { decimals = 2, locale } = {}) {
    const n = normalizeMoneyInput(value);
    const safe = n == null ? 0 : n;
    const resolvedLocale = locale || (typeof navigator !== 'undefined' ? navigator.language : 'fr-FR');
    try {
        return new Intl.NumberFormat(resolvedLocale, {
            minimumFractionDigits: decimals,
            maximumFractionDigits: decimals,
        }).format(safe);
    } catch (e) {
        return safe.toFixed(decimals);
    }
}

const AmountDisplay = ({tariffDisplayMode, invoicingMode, exclAmount, inclAmount, defaultAmount, showTTC = false}) => {
    const styleContext = useStyleContext();
    const { currency } = styleContext;
    const currencySymbol = currency?.symbol ?? '';

    const tariffDisplayModeState =  useMemo(() => {
        return tariffDisplayMode || 'pricing_group';
    }, [tariffDisplayMode])

    const displayedAmount = useMemo(() => {

        let amount = inclAmount ?? "";
        let tariffMode = ""
        const usePricingGroupMode = tariffDisplayModeState === "pricing_group" || !tariffDisplayModeState;
        if(tariffDisplayModeState === "ht" || (usePricingGroupMode && invoicingMode === 'ht')) {
            // if(invoicingMode === 'ht') {
                tariffMode = " HT";
                amount = exclAmount;
            // }
        }
        const numeric =
            normalizeMoneyInput(amount) ??
            ((amount === '' || amount == null) ? normalizeMoneyInput(defaultAmount) : null);
        if (numeric == null) return null;

        return {
            amount: formatMoneyInline(numeric, { decimals: 2 }),
            tariffMode: tariffMode == '' && showTTC ? 'TTC' : tariffMode
        }
    }, [invoicingMode, tariffDisplayModeState, exclAmount, inclAmount, defaultAmount, showTTC]);

    if(displayedAmount == null) { return null }
    
    return (
        <span className={"no-tr"}>
            {displayedAmount.amount}
            {currencySymbol ? `\u00A0${currencySymbol}` : ''}
            {displayedAmount.tariffMode && ` ${displayedAmount.tariffMode}`}
        </span>
    )
}

export default AmountDisplay
